import React, { useEffect, useState } from 'react'
import { Redirect } from 'react-router-dom'
import { authenticate } from '../actions/security'
import { resumeAuth0Session } from '../helpers/resumeAuth0Session'
import Loader from 'uiKit/loaders/loader'

/**
 * After Auth0 silent SSO returns to a PrivateRoute with a session cookie but
 * without SPA localStorage auth, probe the cookie then authenticate() or fall
 * back to classic /login.
 */
const Auth0SessionResume = ({ location }) => {
  const [status, setStatus] = useState('probing') // probing | ok | fail

  useEffect(() => {
    let cancelled = false
    resumeAuth0Session().then(ok => {
      if (cancelled) return
      if (ok) {
        authenticate()
        setStatus('ok')
        return
      }
      setStatus('fail')
    })
    return () => {
      cancelled = true
    }
  }, [])

  if (status === 'probing' || status === 'ok') {
    // ok: parent PrivateRoute re-renders as authenticated after Redux updates.
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
        <Loader />
      </div>
    )
  }

  return (
    <Redirect
      to={{
        pathname: '/login',
        search: location?.search || '',
        state: { from: location, auth0ResumeFailed: true },
      }}
    />
  )
}

export default Auth0SessionResume
